export const CLIENT_ID = '275478579750-f86d1ivh6t1b9haeuiip5btv0cshc4j6.apps.googleusercontent.com'
export const CLIENT_SECRET = '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'
export const REDIRECT_URI = process.env.NODE_ENV === 'production'
  ? 'https://test-360.lndata.com'
  : process.env.NODE_ENV === 'test'
    ? 'https://test-360.lndata.com'
    : 'http://localhost:7011'
